module.exports = __webpack_public_path__ + "static/img/Broeders-Laurien.2dd6773.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/crew_cast/nl/Broeders-Laurien.jpg
// module id = 93Fl
// module chunks = 1